const lang = {
    en: {
        Play: 'Play',
        MoreInfo: 'More Info',
        Search: 'Search',
        SearchWithGPt: 'Search with GPT',
        BarPlaceholder: 'What\'s in your mind',
    },
    hindi: {
        Play: 'चलाएं',
        MoreInfo: 'और जानकारी',
        Search: 'खोज',
        SearchWithGPt: 'GPT के साथ खोजें',
        BarPlaceholder : 'आपके मन में क्या है?',
    },
    jp: {
        Play: '遊ぶ',
        MoreInfo: '詳細情報',
        Search: '検索',
        SearchWithGPt: 'GPTで検索',
        BarPlaceholder: 'あなたの心の中には何がありますか',
    }
}

export default lang